export function InfoPage({ title }: { title: string }) {
  return (
    <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-12">
      <h1 className="text-2xl font-semibold sm:text-3xl">{title}</h1>
      <p className="mt-4 text-sm">Content for this page will be provided by Marketing.</p>
    </main>
  );
}
